import { tv } from "../../../models/text-value.model"

export const getInvoiceTypes = () => {
  return [
    { value: 'fee', text: 'Fee' },
    { value: 'deposit', text: 'Deposit' },
    { value: 'booking_fee', text: 'Booking Fee' },
    { value: 'commission', text: 'Commission' },
    { value: 'expense', text: 'Expense' },
  ];
}

export const getEventArtist = () => {
  return [
    { text: 'Artist', value: 'artist' },
    { text: 'Event', value: 'event' },
  ]
}
export const getVatTypes = () => {
  return [
    { text: 'Vat 1', value: '1' },
    { text: 'Vat 2', value: '2' },
    { text: 'No Vat', value: '0' },
  ]
}
export const getDaysBeforeOptions = () => {
  return [
    { value: 'event', text: 'Event Date'  },
    { value: 'invoice', text: 'Deal Creation Date'  },
  ]
}